import request from "@/utils/http"
import store from "@/store"
import { getCachedObj, removeCache } from "@/utils/cache"
import da from "element-ui/src/locale/lang/da"

export function getProject(projectId) {
  return request.get("/project/getProject", { params: { projectId } }).commonDeal()
}

export function createProject(project) {
  store.dispatch("app/cleanProjectPermission")
  return request.post("/project/createProject", project).commonDeal()
}

export function updateProject(project, projectId) {
  return request.post("/project/updateProject", project, { params: { projectId } }).commonDeal()
}

export function addProjectMembers(members, projectId) {
  return request.post("/project/addProjectMembers", members, { params: { projectId } }).commonDeal()
}

export function deleteProjectMembers(members, projectId) {
  return request
    .post("/project/deleteProjectMembers", members, { params: { projectId } })
    .commonDeal()
}

export function updateMemberRoles(roles, userId, projectId) {
  return request
    .post("/project/updateMemberRoles", roles, { params: { userId, projectId } })
    .commonDeal()
}

export function saveProjectRole({ id, name, description, mainAssignee }, projectId) {
  return request
    .post(
      "/project/saveProjectRole",
      { id, name, description, mainAssignee },
      { params: { projectId } }
    )
    .commonDeal()
}

export function deleteProjectRole(roleId) {
  return request.post("/project/deleteProjectRole", null, { params: { roleId } }).commonDeal()
}

export function getAllProjectRole(projectId) {
  return request.get("/project/getAllProjectRole", { params: { projectId } }).commonDeal()
}

export function getProjectMembers(projectId) {
  return request.get("/project/getProjectMembers", { params: { projectId } }).commonDeal()
}

export function getProjectUsers(projectId) {
  let key = `getProjectUsers_${projectId}`
  let reqFunc = () => request.get("/users/getProjectUsers", { params: { projectId } }).commonDeal()
  return getCachedObj({ key, reqFunc })
}

/*
项目里程碑
*/

// 获取项目里程碑列表
export function getMilestoneTasks(projectId) {
  return request.get("/project/getMilestoneTasks", { params: { projectId } }).commonDeal()
}

// 生成项目里程碑历史版本
export function createMilestoneHistory(version, projectId) {
  return request
    .post("/project/createMilestoneHistory", version, { params: { projectId } })
    .commonDeal()
}

// 查看历史版本
export function getMilestoneHistory(projectId) {
  return request.get("/project/getMilestoneHistory", { params: { projectId } }).commonDeal()
}

// 查看历史版本详情
export function getMilestoneDetail(milestoneId) {
  return request.get("/project/getMilestoneDetail", { params: { milestoneId } }).commonDeal()
}

/*
项目风险
*/

// 获取项目风险列表
export function getRiskTasks(projectId) {
  return request.get("/project/getRiskTasks", { params: { projectId } }).commonDeal()
}

/**
 * 获取项目列表
 * @param type ALL, MEMBER, MANAGE
 * @param withCount 是否返回任务完成数
 * @param cache
 * @returns {Promise<*[]>|Promise<unknown>}
 */
export function getProjectList({ type = "MEMBER", withCount = false, cache = false } = {}) {
  if (store.getters.isTemplateMode) {
    return Promise.resolve([])
  }
  let key = `getProjectList_${type}_${withCount}`
  let reqFunc = () =>
    request
      .get("/project/getProjectList", { params: { type, withCount } })
      .commonDeal()
      .then(data => {
        if (withCount) {
          data.forEach(project => {
            project.completeRate =
              project.totalTaskCount == 0
                ? 0
                : (project.completedTaskCount * 1.0) / project.totalTaskCount
          })
        }
        return data
      })
  if (!cache) {
    removeCache(key)
  }
  return getCachedObj({ key, reqFunc })
}

export function updateProjectPrivilege(privileges, projectId, publicMode, roleList) {
  return request
    .post(
      "/project/updateProjectPrivilege",
      { privileges, publicMode, roleList },
      { params: { projectId } }
    )
    .commonDeal()
}

export function getUserPri() {
  return request.get("/project/getUserPri")
}

/**
 * 新建或更新
 * @param id 新建时传null,更新时传id
 * @param name
 * @param companyId
 * @param refAppId
 * @param refSheetId
 * @param fillCids
 * @returns {*}
 */
export function saveTaskType({
  id,
  name,
  refAppId,
  refSheetId,
  description,
  fillCids = [],
  shareResult
}) {
  return request
    .post("/project/saveTaskType", {
      id,
      name,
      refAppId,
      refSheetId,
      description,
      fillCids,
      shareResult
    })
    .commonDeal()
}

export function deleteTaskType(taskTypeId) {
  return request.post("/project/deleteTaskType", null, { params: { taskTypeId } }).commonDeal()
}

export function getTaskTypeList() {
  return request.get("/project/getTaskTypeList").commonDeal()
}

/**
 * 添加任务类型到项目
 * @param taskTypeIdList
 * @param projectId
 */
export function addTaskTypeListToProject(taskTypeIdList, projectId) {
  return request
    .post("/project/addTaskTypeListToProject", taskTypeIdList, { params: { projectId } })
    .commonDeal()
}

export function setTaskTypeDefWorkflow(taskTypeId = "", projectId, workflowId) {
  return request
    .post("/project/setTaskTypeDefWorkflow", null, {
      params: { taskTypeId, projectId, workflowId }
    })
    .commonDeal()
}

export function removeProjectTaskType(taskTypeId, projectId) {
  return request
    .post("/project/removeProjectTaskType", null, { params: { taskTypeId, projectId } })
    .commonDeal()
}

export function getTaskTypeListByProject(projectId) {
  return request.get("/project/getTaskTypeListByProject", { params: { projectId } }).commonDeal()
}

export function getProjectLogList(projectId) {
  return request.get("/project/getProjectLogList", { params: { projectId } }).commonDeal()
}

/**
 * 获取模板列表
 * @param type ALL, MANAGE
 * @returns {Promise<unknown>}
 */
export function getProjectTemplates(type = "MANAGE") {
  return request.get("/project/getProjectTemplates", { params: { type } }).commonDeal()
}

export function createProjectTemplate(projectId, project) {
  store.dispatch("app/cleanProjectPermission")
  return request
    .post("/project/createProject/template", project, { params: { projectId } })
    .commonDeal()
}

export function deleteProjectTemplate(templateId) {
  return request
    .post("/project/deleteProject/template", null, { params: { templateId } })
    .commonDeal()
}

export function createProjectByTemplate(templateId, project) {
  store.dispatch("app/cleanProjectPermission")
  return request
    .post("/project/createProject/ByTemplate", project, { params: { templateId } })
    .commonDeal()
}

export function suspendProject(projectId, suspend) {
  return request
    .post("/project/suspendProject", null, { params: { projectId, suspend } })
    .commonDeal()
}
